import store from '@/store'
import axios from 'axios'

export default {

  async getUsersByCompany () {
    try {
      let result = await axios.get(store.getters.getOpaApi + '/user?companyId=' + store.state.company.companyId)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao obter consumidores'}
      }  
    } catch (e) {
      let error = {e} 
      console.log(error) 
      return { error: true, data: error, msg: 'Erro ao obter consumidores'} 
    }
  }
}